export default function Footer() {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#1C1C1C] text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="text-2xl font-bold mb-4 font-['Playfair_Display'] text-[#D4AF37]">
              Terra Construction
            </div>
            <p className="text-white/70 mb-6 leading-relaxed max-w-md">
              Crafting luxury outdoor living spaces with premium construction and innovative 3D design renderings. 
              Transform your outdoor vision into reality with our expert team.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gradient-to-r from-[#D4AF37] to-[#B8860B] rounded-full flex items-center justify-center hover:from-[#F5E6A3] hover:to-[#E6D293] hover:text-[#1C1C1C] transition-all cursor-pointer"
              >
                <i className="ri-instagram-line"></i>
              </a>
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gradient-to-r from-[#D4AF37] to-[#B8860B] rounded-full flex items-center justify-center hover:from-[#F5E6A3] hover:to-[#E6D293] hover:text-[#1C1C1C] transition-all cursor-pointer"
              >
                <i className="ri-facebook-line"></i>
              </a>
              <a 
                href="https://houzz.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gradient-to-r from-[#D4AF37] to-[#B8860B] rounded-full flex items-center justify-center hover:from-[#F5E6A3] hover:to-[#E6D293] hover:text-[#1C1C1C] transition-all cursor-pointer"
              >
                <i className="ri-home-line"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#D4AF37]">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('home')}
                  className="text-white/70 hover:text-[#D4AF37] transition-colors cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('about')}
                  className="text-white/70 hover:text-[#D4AF37] transition-colors cursor-pointer"
                >
                  About Us
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-white/70 hover:text-[#D4AF37] transition-colors cursor-pointer"
                >
                  Services
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('portfolio')}
                  className="text-white/70 hover:text-[#D4AF37] transition-colors cursor-pointer"
                >
                  Portfolio
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="text-white/70 hover:text-[#D4AF37] transition-colors cursor-pointer"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#D4AF37]">Our Services</h3>
            <ul className="space-y-3 text-sm">
              <li className="text-white/70">3D Landscape Design</li>
              <li className="text-white/70">Turf Installation</li>
              <li className="text-white/70">Retaining Walls</li>
              <li className="text-white/70">Paver Patios</li>
              <li className="text-white/70">Irrigation Systems</li>
              <li className="text-white/70">Outdoor Lighting</li>
            </ul>
          </div>
        </div>

        {/* Bottom section */}
        <div className="border-t border-[#D9C5A0]/30 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-[#1C1C1C]/70 text-sm mb-4 md:mb-0">
              © 2024 Terra Construction. All rights reserved.
            </p>
            
            <div className="flex items-center space-x-6">
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-[#D4AF37] transition-colors cursor-pointer text-[#1C1C1C]/70 text-sm"
              >
                Bonded & Insured
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
